import {
  FETCH_BACKLINKS_OVERVIEW_IN_PROGRESS,
  FETCH_BACKLINKS_OVERVIEW_SUCCESS,
  FETCH_BACKLINKS_OVERVIEW_FAILED,
  FETCH_BACKLINKS_IN_PROGRESS,
  FETCH_BACKLINKS_SUCCESS,
  FETCH_BACKLINKS_FAILED,
  FETCH_REFERRING_DOMAINS_IN_PROGRESS,
  FETCH_REFERRING_DOMAINS_SUCCESS,
  FETCH_REFERRING_DOMAINS_FAILED,
  FETCH_TOP_ANCHORS_IN_PROGRESS,
  FETCH_TOP_ANCHORS_SUCCESS,
  FETCH_TOP_ANCHORS_FAILED,
  FETCH_TLD_DISTRIBUTION_IN_PROGRESS,
  FETCH_TLD_DISTRIBUTION_SUCCESS,
  FETCH_TLD_DISTRIBUTION_FAILED,
  FETCH_TOP_COUNTRIES_IN_PROGRESS,
  FETCH_TOP_COUNTRIES_SUCCESS,
  FETCH_TOP_COUNTRIES_FAILED
} from "./types";

const getActionType = (resourceType, fetchStatus) => {
  let actionTypes = {
    backlinks: {
      in_progress: FETCH_BACKLINKS_IN_PROGRESS,
      success: FETCH_BACKLINKS_SUCCESS,
      failed: FETCH_BACKLINKS_FAILED
    },
    referring_domains: {
      in_progress: FETCH_REFERRING_DOMAINS_IN_PROGRESS,
      success: FETCH_REFERRING_DOMAINS_SUCCESS,
      failed: FETCH_REFERRING_DOMAINS_FAILED
    },
    top_anchors: {
      in_progress: FETCH_TOP_ANCHORS_IN_PROGRESS,
      success: FETCH_TOP_ANCHORS_SUCCESS,
      failed: FETCH_TOP_ANCHORS_FAILED
    },
    tld_distribution: {
      in_progress: FETCH_TLD_DISTRIBUTION_IN_PROGRESS,
      success: FETCH_TLD_DISTRIBUTION_SUCCESS,
      failed: FETCH_TLD_DISTRIBUTION_FAILED
    },
    top_countries: {
      in_progress: FETCH_TOP_COUNTRIES_IN_PROGRESS,
      success: FETCH_TOP_COUNTRIES_SUCCESS,
      failed: FETCH_TOP_COUNTRIES_FAILED
    }
  };

  if (resourceType in actionTypes && fetchStatus in actionTypes[resourceType]) {
    return actionTypes[resourceType][fetchStatus];
  }

  return null;
};

export const fetchBacklinksOverviewInProgress = (resourceType, domain) => {
  return { type: FETCH_BACKLINKS_OVERVIEW_IN_PROGRESS, resourceType, domain };
};

export const fetchBacklinksOverviewSuccess = (resourceType, domain, overview) => {
  return { type: FETCH_BACKLINKS_OVERVIEW_SUCCESS, resourceType, domain, overview };
};

export const fetchBacklinksOverviewFailed = (resourceType, domain) => {
  return { type: FETCH_BACKLINKS_OVERVIEW_FAILED, resourceType, domain };
};

export const fetchResourceInProgress = (resourceType, domain, orderBy, orderDir) => {
  return { type: getActionType(resourceType, "in_progress"), resourceType, domain, orderBy, orderDir };
};

export const fetchResourceSuccess = (resourceType, domain, orderBy, orderDir, response) => {
  return { type: getActionType(resourceType, "success"), resourceType, domain, orderBy, orderDir, response };
};

export const fetchResourceFailed = (resourceType, domain, orderBy, orderDir) => {
  return { type: getActionType(resourceType, "failed"), resourceType, domain, orderBy, orderDir };
};
